/** Statuses that can be assigned to a demo when no active demo exists. */
export const DEMO_SCHEDULE_BASE_STATUSES = ['new', 'wip_before_demo', 'deferred', 'demo_reschedule_requested'];

/**
 * Whether a lead can be picked when creating a demo or adding to an existing demo.
 * Includes leads stuck in demo_scheduled with no scheduled demo on record.
 */
export function isLeadEligibleForDemoScheduling(lead) {
  if (!lead || lead.status === 'won') return false;
  if (lead.has_scheduled_demo) return false;

  if (DEMO_SCHEDULE_BASE_STATUSES.includes(lead.status)) return true;

  // Orphaned status: marked demo_scheduled but no active demo (cancelled/removed never reverted)
  if (lead.status === 'demo_scheduled') return true;

  return false;
}

export function filterLeadsEligibleForDemo(leads) {
  return (leads || []).filter(isLeadEligibleForDemoScheduling);
}
